var PageEntryPoint =
webpackJsonpPageEntryPoint([14],{

/***/ "/4E9":
/***/ (function(module, exports, __webpack_require__) {

var jade = __webpack_require__("TBTh");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (ctaLabel, ctaTarget, ctaUrl) {
buf.push("<div class=\"container-row\"><a href=\"" + (jade.escape((jade_interp = ctaUrl) == null ? '' : jade_interp)) + "\" target=\"" + (jade.escape((jade_interp = ctaTarget) == null ? '' : jade_interp)) + "\" class=\"cta-button\">" + (jade.escape((jade_interp = ctaLabel) == null ? '' : jade_interp)) + "</a></div>");}.call(this,"ctaLabel" in locals_for_with?locals_for_with.ctaLabel:typeof ctaLabel!=="undefined"?ctaLabel:undefined,"ctaTarget" in locals_for_with?locals_for_with.ctaTarget:typeof ctaTarget!=="undefined"?ctaTarget:undefined,"ctaUrl" in locals_for_with?locals_for_with.ctaUrl:typeof ctaUrl!=="undefined"?ctaUrl:undefined));;return buf.join("");
}

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "7Iys":
/***/ (function(module, exports, __webpack_require__) {

var jade = __webpack_require__("TBTh");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (isLoggedIn) {
var linkId = (isLoggedIn === true) ? 'navbar-logout-link' : 'navbar-login-link'
var linkClass = (isLoggedIn === true) ? 'webchat-myvhi-logout' : 'webchat-myvhi-login'
var btnText = (isLoggedIn === true) ? 'common:header.logout' : 'common:header.login'
var url =  (isLoggedIn === true) ? "javascript:window.location.href='logout';" : '/myvhi'
buf.push("<a" + (jade.attr("id", '' + (linkId) + '', true, true)) + (jade.attr("href", '' + (url) + '', true, true)) + (jade.cls(['navbar-login-link ' + (linkClass) + ''], [true])) + "><button id=\"navbar-login-btn\"" + (jade.attr("data-i18n", "" + (btnText) + "", true, true)) + " class=\"navbar-login-btn\">Log out</button></a>");}.call(this,"isLoggedIn" in locals_for_with?locals_for_with.isLoggedIn:typeof isLoggedIn!=="undefined"?isLoggedIn:undefined));;return buf.join("");
}

/***/ }),

/***/ "CCE4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("7t+N");
var urls = __webpack_require__("g+w9");

var ajaxStatusConfig = {
    STATUS_GONE: 410,
    UNPROCESSABLE: 422,
	NOT_IMPLEMENTED: 501
};

function ajaxGetJson(config){
	return $.ajax({
					url : config.url,
					dataType: 'json',
					contentType: 'application/json; charset=utf-8',
					headers: config.headers,
					data: getJsonString(config),
					async	: getAsync(config),
					type : 'GET'
			});
}

function ajaxPostJson(config) {
	return $.ajax({
		url : config.url,
		dataType: 'json',
		contentType: 'application/json; charset=utf-8',
		headers: getHeaders(config),
		data: getJsonString(config),
		async	: getAsync(config),
		type : 'POST',
		timeout: config.timeout
	});
}

function getJsonString(config){
	return (typeof config.jsonString !== 'undefined') ? config.jsonString : '';
}

function getAsync(config) {
	if (typeof config.async === 'undefined') {
		return true;
	} else {
		return config.async;
	}
}

function getHeaders(config){
	return (typeof config.headers !== 'undefined') ? config.headers : '';
}

/**
 * Helper method to be used in .fail() handler of jquery AJAX requests
 * Provides generic failure handling and ability to ignore certain codes
 * @param message
 * @param ignoreCodes - optional array of numbers for status codes for which error handling won't be invoked
 * @returns {Function}
 */
function handleError(message, ignoreCodes) {
    return function (jqXHR, status, faf) {
        if (ignoreCodes && ignoreCodes.indexOf(jqXHR.status) > -1) {
            console.log('Skipping processing of error code ' + jqXHR.status);
        } else {
            errorHandler(jqXHR, message);
        }
    };
}

/**
 * Jquery ajax error handler
 */
function errorHandler(jqXHR, message) {
    console.error('ajaxHandler.errorHandler '+jqXHR.status+' '+ message);
    if (jqXHR.status === ajaxStatusConfig.UNPROCESSABLE) {
        return;
    }

    if (jqXHR.status === ajaxStatusConfig.STATUS_GONE) {
        urls.navigateToUrl("/groups"+'/session-expired');
        return;
    }

    if (jqXHR.status === ajaxStatusConfig.NOT_IMPLEMENTED) {
        urls.navigateToUrl("/groups"+'/not-supported');
        return;
    }
	urls.navigateToUrl("/groups"+'/internal-problem');

}

module.exports = {
	ajaxGetJson : ajaxGetJson,
	ajaxPostJson: ajaxPostJson,
    handleError: handleError,
	errorHandler: errorHandler,
};



/***/ }),

/***/ "GjX5":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Registers event handlers for the Journey Panel on the Home Page.
 * 
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__("7t+N"),
    __webpack_require__("dpXw")
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, enrolmentCommons) {
	
    'use strict';

    var config = {
        journeyPanelJoinBtnId: 'journey-join-transfer-button',
		journeyPanelAddDepBtnId: 'journey-add-dependant-button',
        intlJoinTodayBtn1Id: 'international-join-today-button-1',
        intlJoinTodayBtn2Id: 'international-join-today-button-2'
    };
    
    
    /**
     * Handler for the Button click events on the "Yes/No" buttons.
     */
    function registerBtnClickHandlers(isCustomEnrolmentFlag, schemeNo, vhiContactList) {


        // Temp for covid-19
        //$('#'+config.journeyPanelAddDepBtnId).on('click', handleButtonClickEvent(vhiContactList));

    	//override default flow only if Custom Enrolment has been enabled.
    	if(isCustomEnrolmentFlag){
            var isContentAvailablePromise = isEnrolmentContentAvailable(schemeNo);
            isContentAvailablePromise.done(function () {
                $('#'+config.journeyPanelJoinBtnId).on('click', handleButtonClickEvent(schemeNo));
                $('#'+config.journeyPanelAddDepBtnId).on('click', handleButtonClickEvent(schemeNo));
                $('#'+config.intlJoinTodayBtn1Id + ', #'+config.intlJoinTodayBtn2Id).on('click', handleButtonClickEvent(schemeNo));
            });
            return isContentAvailablePromise;
    	} else {
    		return $.Deferred().reject(false);
		}
/* LEFT COMMENTED OUT IN CASE RERATE RELATED POP-UP NEEDS TO BE TURNED ON QUICKLY
    	function handleAddDependentButtonClickEvent(vhiContactList) {
    	    return function (eventObj) {
                // Display covid-19 explainer popup
                eventObj.preventDefault();

                var $this = $(eventObj.currentTarget);

                var transactionType = $this.attr('data-journey-type');
                var href = '/groups';

                var contactNumber = vhiContactList[0].contactNumber;
                $('#rerate-contact-number').html(contactNumber);

                var closeButton = $('#rerate-time');
                closeButton.attr('href', href);
                closeButton.attr('data-journey-type', transactionType);

                var modalPanel = $('#rerate-modal');
                modalPanel.localize({"context" : transactionType});
                modalPanel.modal('show');
            };
        }
*/
        /**
         * Helper function.
         */
        function handleButtonClickEvent(schemeNo) {
            return function (eventObj) {
                eventObj.preventDefault();
                var clickedButtonId = eventObj.target.id;
                var navigationTarget = null;
                var targetRoot = 'groups';
                if(clickedButtonId===config.journeyPanelJoinBtnId) {
                    navigationTarget = "join-details-start";
                }
                else if(clickedButtonId===config.journeyPanelAddDepBtnId) {
                    navigationTarget = "add-dependant";
                }
                else if(clickedButtonId === config.intlJoinTodayBtn1Id || clickedButtonId === config.intlJoinTodayBtn2Id) {
                    navigationTarget = "join-details-start";
                    targetRoot = 'intgroups';
                }

                var enrolmentConfig = enrolmentCommons.getConfig(targetRoot, navigationTarget);
                enrolmentCommons.updateEnrolmentContent(schemeNo, enrolmentConfig);
            };
        }
    }
    
    
    function registerEventListeners(isCustomEnrolmentFlag, schemeNo, vhiContactList){
    	console.log('Registering Journey Panel event listeners');
    	return registerBtnClickHandlers(isCustomEnrolmentFlag, schemeNo, vhiContactList);
    }
    
    function isEnrolmentContentAvailable(schemeNo){
    	var customEnrolmentContentUrl = '/online-services/enrolment-content/' + schemeNo + '/groups';

        return $.ajax({
            type: 'GET',
            url: customEnrolmentContentUrl,
            async: true,
            dataType: 'json'
        }).then(function (data) {
            return true;
        }, function (error) {
            return false;
        });
    }

    
    /**
     * Expose API to caller.
     * 
     */
    return {
    	registerEventListeners: registerEventListeners
    };
    
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "IwI5":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("olBI"),
        __webpack_require__("7t+N"),
        __webpack_require__("RVtR"),
        __webpack_require__("KFdh"),
        __webpack_require__("CCE4"),
        __webpack_require__("GjX5"),
        __webpack_require__("rzgQ"),
        __webpack_require__("Mhog"),
        __webpack_require__("OBNk"),
        __webpack_require__("v8hp"),
        __webpack_require__("edcJ"),
        __webpack_require__("pHlT"),
        __webpack_require__("rqn6"),
        __webpack_require__("FqQr")
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function(i18n, $, usualPageSetup, positioning, ajaxHandler, journeyPanel, contactPanel, customContentPanel, disablingLayer, analyiticsData, renewalsPanelTemplate, groupSchemeService, footer, urlsUtils) {
        'use strict';

        disablingLayer.showDisablingLayer();

        var groupSchemeBasicInfoPromise;
        var i18nPromise;

        return {init: init};
        function init() {
            var groupSchemeToken = urlsUtils.getUrlParameter(window.location.href, "token");
            if (groupSchemeToken) {
                groupSchemeBasicInfoPromise = groupSchemeService.getGroupScheme(true, groupSchemeToken);
            } else {
                groupSchemeBasicInfoPromise = groupSchemeService.getGroupScheme(true);
            }
            i18nPromise = i18n.init();
            return $.when(groupSchemeBasicInfoPromise, i18nPromise)
                .then(usualPageSetup.init(true))
                .then(function (groupSchemeBasicInfoData, i18nData) {

                    populateAnalyitics(groupSchemeBasicInfoData);

                    var schemeName = groupSchemeBasicInfoData.schemeName;
                    var schemeNo = groupSchemeBasicInfoData.schemeId;
                    var vhiContactList = groupSchemeBasicInfoData.vhiContacts;
                    var isCustomEnrolmentFlag = groupSchemeBasicInfoData.customEnrolmentFlag;
                    var enableJourneyPanels = groupSchemeBasicInfoData.enableOnlineSales;

                    if (enableJourneyPanels) {
                        $('.journeysPanel').show();
                    }

                    if (groupSchemeBasicInfoData.showRenewals) {
                        $('#renewal-panel').replaceWith(renewalsPanelTemplate({}));
                    }

                    contactPanel.render(groupSchemeBasicInfoData);
                    positioning.applySameHeights();
                    journeyPanel.registerEventListeners(isCustomEnrolmentFlag, schemeNo, vhiContactList);
                    customContentPanel.populateCustomContent(schemeNo, 'groups',
                        $('#custom-content-dynamic-content'), showCustomContentHeader);

                    //userStory 2212, hide footer contacts in groups dashboard page
                    if ((vhiContactList && vhiContactList.length > 0) && ('WVC'===vhiContactList[0].roleType)) {
                        footer.hideContactDetails();
                    }

                    localizeStaticContent(schemeName, schemeNo);

                    disablingLayer.hideDisablingLayer();

                })
                .fail(function (e) {
                    //fallback - try to localize without scheme specific data
                    $('body').localize();
                    positioning.applySameHeights();
                    ajaxHandler.handleError(e);

                    disablingLayer.hideDisablingLayer();
                });
        }

        function showCustomContentHeader() {
            $('#custom-content-header').show();
        }

        function populateAnalyitics(groupSchemeBasicInfo) {
            analyiticsData.populateSchemeData({
                schemeId: groupSchemeBasicInfo.schemeId,
                schemeName: groupSchemeBasicInfo.schemeName,
                categoryId: groupSchemeBasicInfo.categoryId,
                categoryName: groupSchemeBasicInfo.categoryName
            });
        }

        function localizeStaticContent(schemeName, schemeNo) {
            $('body').localize();
            $('[class^=banner-panel]').localize({ groupName: schemeName, schemeNo: schemeNo });
        }

    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "JOWb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__("Eb2/").namespace('groups');


/***/ }),

/***/ "RVtR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by c_razmuss_a on 12/10/2017.
 */


var $ = __webpack_require__("7t+N");
__webpack_require__("gNGx");
var positioning = __webpack_require__("KFdh");
var groupSchemeService = __webpack_require__("pHlT");
var header = __webpack_require__("iPHx");
var footer = __webpack_require__("rqn6");
var loginStatusService = __webpack_require__("Ytzv");

function init(isLoginLogoutCta) {
    // Show/hide logout CTA
    var headerCb = (isLoginLogoutCta === true) ? header.initWithLoginCta : header.init;
    var loggedInPromise = loginStatusService.getIsUserLoggedIn();
    loggedInPromise.done(function(isLoggedIn) {
        headerCb(isLoggedIn, true);
    });

    var contactInfoPromise = groupSchemeService.getContactInformation();
    contactInfoPromise.done(footer.init);

    positioning.sameHeightConfig.minWidth = 0;
    positioning.registerSameHeightListener();

    return $.when(contactInfoPromise, loggedInPromise);
}

module.exports.init = init;


/***/ }),

/***/ "Ytzv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("7t+N");

function getIsUserLoggedIn(){
    var userLoggedInPromise = $.Deferred();
    $.get( "/groups" + '/rest/accessManagement/loginStatus')
        .done(function (data) {
                console.log("getIsUserLoggedIn : " + data);
                if(data.loggedIn===true){
                    userLoggedInPromise.resolve(true);
                }else{
                    userLoggedInPromise.resolve(false);
                }
        })
        .fail(function(jqXHR, textStatus, error) {
            console.log( "error: status = %s", jqXHR.status);
            console.log( "error: responseText = %s", jqXHR.responseText);
            console.log( "error: textStatus = %s", textStatus);
            console.log( "error: error = %s", error);
            userLoggedInPromise.resolve(false);
        });

    return userLoggedInPromise.promise();
}

module.exports.getIsUserLoggedIn = getIsUserLoggedIn;

/***/ }),

/***/ "dpXw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("7t+N");
var enrolmentCtaButtonTemplate = __webpack_require__("/4E9");
var disablingLayer = __webpack_require__("OBNk");
var DOMPurify = __webpack_require__("OvQW");

function getConfig(uncheckedSource, uncheckedTarget, groupSchemeToken) {
    var MYVHI_SOURCE = /^myvhi$/i;
    var GROUPS_SOURCE = /^groups$/i;
    var INTL_GROUPS_SOURCE = /^intgroups$/i;

    var JOIN_TARGET = /^join-details-start$/i;
    var ADD_DEPENDANT_TARGET = /^add-dependant$/i;
    var INTL_JOIN_TARGET = /^join-details-start$/i;

    if (MYVHI_SOURCE.test(uncheckedSource)) {
        return {
            targetUrl: "/myvhi",
            ctaLabel: "Close",
            errorUrl: "/myvhi/error",
            groupSchemeToken: groupSchemeToken
        };
    }

    if (INTL_GROUPS_SOURCE.test(uncheckedSource)) {
        var resolvedIntlTarget = getIntlGroupsNavigationTarget(uncheckedTarget);
        return {
            targetUrl: resolvedIntlTarget,
            ctaLabel: "Continue",
            errorUrl: resolvedIntlTarget,
        };
    }
    else if (GROUPS_SOURCE.test(uncheckedSource)) {
        var resolvedTarget = getGroupsNavigationTarget(uncheckedTarget);
        return {
            targetUrl: resolvedTarget,
            ctaLabel: "Continue",
            errorUrl: resolvedTarget,
        };
    }

    redirectToGenericErrorPage('source');

    function getGroupsNavigationTarget(uncheckedTarget){
        if (JOIN_TARGET.test(uncheckedTarget)) {
            return "/groups/join-details-start";
        }

        if(ADD_DEPENDANT_TARGET.test(uncheckedTarget)) {
            return "/groups/add-dependant";
        }
        redirectToGenericErrorPage("source");
    }

    function getIntlGroupsNavigationTarget(uncheckedTarget){
        if (INTL_JOIN_TARGET.test(uncheckedTarget)) {
            return "/intgroups/join-details-start";
        }

        redirectToGenericErrorPage("source");
    }

    function redirectToGenericErrorPage(source) {
        console.error('Invalid ' + source + ' system. No configuration exists');
        window.location.replace('/groups/error');
    }
}

/**
 * @param schemeNo
 * @param config
 * @returns
 */
function updateEnrolmentContent(schemeNo, config) {

    var customEnrolmentContentUrl = '/online-services/enrolment-content/' + schemeNo + '/groups';

    $.ajax({
        type: 'GET',
        url: customEnrolmentContentUrl,
        dataType: 'json'
    }).done(function(data) {
        try {
            // Inject html into content area
            processCustomContent(data);
            disablingLayer.hideDisablingLayer();
        }
        catch(error) {
            handleException(config.errorUrl, error, schemeNo);
        }
    }).fail(function(jqXHR, textStatus, error) {
        // hide custom content region
        console.log( "error: status = %s", jqXHR.status);
        console.log( "error: responseText = %s", jqXHR.responseText);
        console.log( "error: textStatus = %s", textStatus);
        console.log( "error: error = %s", error);
        // bypass custom content and continue on journey.
        handleException(config.errorUrl, error, schemeNo);
    });

    updateCtaButton();

    /**
     * Process the custom content JSON object.
     */
    function processCustomContent(data) {
        var $enrolmentModal = $('#enrolment-modal');
        var html = DOMPurify.sanitize(data.enrolmentContent, { ADD_ATTR: ['target']});

        document.getElementById('custom-content').innerHTML = html;
        $enrolmentModal.modal('show');
        $enrolmentModal.on("hidden.bs.modal", function(){
            $('#custom-content').empty();
            $('#cta-button').empty();
        });
    }


    function updateCtaButton() {

        var dataObj = {
            ctaUrl: config.targetUrl,
            ctaTarget: "_self",
            ctaLabel: config.ctaLabel
        };

        var html = enrolmentCtaButtonTemplate(dataObj);
        var $placeHolder = $('#cta-button');
        $placeHolder.html(html);
    }

    /**
     * Logs the exception to the server and redirects to the desired URL.
     * @param targetUrl
     * @param error
     * @param schemeNo
     */
    function handleException(targetUrl, error, schemeNo){

        console.log( "Failed to display custom enrolment content" + error.message);

        try {
            var logEntry = "Failed to display custom enrolment content";
            logErrorToTheCustomEnrolmentContentService(logEntry, schemeNo);
        }
        catch(e) {
            console.log( "error: error = %s", "Failed to log error to server");
        }

        window.location.replace(targetUrl);
    }


    /**
     * Logs the <code>LogEntry</code> to the CustomEnrolmentContentService.
     *
     * @param logEntry
     * @param schemeNo
     */
    function logErrorToTheCustomEnrolmentContentService(logEntry, schemeNo){

        var logEntryConcat = "Failed to display cutom enrolment content. Error message: " + logEntry;
        var customEnrolmentContentLogUrl = '/online-services/enrolment-content/logs/' + schemeNo + '/groups/' + logEntryConcat;
        $.ajax({
            url : customEnrolmentContentLogUrl,
            dataType : 'json',
            contentType : 'application/json; charset=utf-8',
            data : null,
            async : true,
            type : 'POST'
        });
    }

}

module.exports = {
    getConfig: getConfig,
    updateEnrolmentContent: updateEnrolmentContent
};



/***/ }),

/***/ "edcJ":
/***/ (function(module, exports, __webpack_require__) {

var jade = __webpack_require__("TBTh");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div id=\"renewal-panel\" class=\"renewal-panel\"><div class=\"renewals-content\"><h5 data-i18n=\"renewalsPanel.header\"></h5><p data-i18n=\"renewalsPanel.text\"> </p></div><a href=\"/myvhi/online-renewals\"><button id=\"renewal-login-btn\" data-i18n=\"renewalsPanel.button\" class=\"renewal-login-btn\"></button></a></div>");;return buf.join("");
}

/***/ }),

/***/ "g+w9":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    'use strict';

    var testUrlParameters;

    function getAllUrlParameters() {
        if (testUrlParameters) {
            return testUrlParameters;
        }
        return window.location.search.substring(1);
    }

    function getUrlPath() {
        return window.location.pathname;
    }

    function redirectToUrl(destinationUrl) {
        window.location.replace(destinationUrl);
    }

    function navigateToUrl(destinationUrl) {
        window.location.href = destinationUrl;
    }

    return {
        getUrlParameter: function (paramName) {
            var params = getAllUrlParameters();
            console.log(params);
            var paramList = params.split('&');

            for (var i = 0; i < paramList.length; i++) {
                var param = paramList[i].split('=');
                if (param[0] === paramName) {
                    return param[1];
                }
            }
        },
        getAllUrlParameters: getAllUrlParameters,
        setTestUrlParameters: function (urlParameters) {
            testUrlParameters = urlParameters;
        },
        redirectToUrl: redirectToUrl,
        navigateToUrl: navigateToUrl,
        getUrlPath: getUrlPath
    };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "iPHx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("7t+N");
var stickyHeader = __webpack_require__("j7WF");

/**
 * Initialises the header state.
 * <p>
 * Takes a promise as argument that return true/false.
 * If the promise resolves to true, the log out CTA is displayed.
 * For all other resolution states the log out CTA in NOT displayed.
 * </p>
 */
function init(isLoggedIn) {
    stickyHeader.apply('nav-bar-top', 'page-container', false);
    showHideLogoutCTA(isLoggedIn);
}

function initWithLoginCta(isLoggedIn, isGroups) {
    stickyHeader.apply('nav-bar-top', 'page-container', false);

    if (isGroups || (!isGroups && isLoggedIn)) {
        var loginButtonTemplate = __webpack_require__("7Iys");
        var html = loginButtonTemplate({isLoggedIn: isLoggedIn});
        var $placeHolder = $('#login-btn-dynamic-content');
        $placeHolder.html(html);
    }
}

/**
 * Displays or hides the Logout CTA.
 * @param aBoolean if true the Logout CTA is displayed, remains hidden otherwise.
 */
function showHideLogoutCTA(aBoolean){
    if(aBoolean===true){
        $('#nav-logout').show();
    }else{
        $('#nav-logout').hide();
    }
}

module.exports = {
    init: init,
    initWithLoginCta: initWithLoginCta
};

/***/ }),

/***/ "lwx0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("7t+N");
var jqueryI18next = __webpack_require__("+ZPT");
var i18next = __webpack_require__("QCdE");
var backend = __webpack_require__("OcWW");
var cache = __webpack_require__("IdM4");

var defaultOptions = {
    //debug: true,
    lng: 'en',
    fallbackLng: 'en',
    //ns: [],
    interpolation: {'escapeValue': false},
    backend: {
        loadPath: function(lng, ns){
            if(ns.indexOf('plan-names') !== -1){
                return '/online-services/plan-names';
            }else{
                return '/groups/' + 'locales/' + lng + '/' + ns + '.json';
            }
        }
    },
    cache:
        {
            enabled: true,
            // prefix for stored languages
            prefix: 'i18next_res_',
            // expiration (10 mins)
            expirationTime: 10 * 60 * 1000
        }
};

function doSetup(options) {
    var mergedOpts = $.extend({}, defaultOptions, options);

    jqueryI18next.init(i18next, $);

    var deferred = $.Deferred();

    i18next.use(backend)
        .use(cache)
        .init(mergedOpts, function(err, t) {
            if (err) {
                console.error(err);//all bad failed to initialize
            } else {
                deferred.resolve(i18next); //now we can translate
            }
        });

    return deferred.promise();
}

/**
 * Returns a function to be used for jquery validator.
 * Validator doesn't support promises, thus we expect i18n has already been initialized
 * if you need regular translations in javascript better use i18next resolved value from i18n.init() promise
 * @param key
 * @returns {Function}
 */
function translate(key) {
    return function() {
        return i18next.t(key);
    };
}

module.exports = {
    doSetup: doSetup,
    translate: translate
};



/***/ }),

/***/ "olBI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var i18n = __webpack_require__("lwx0");

var options = {
    ns: ['corpJourney', 'lcr', 'plan-names', 'common'],
    defaultNS: 'corpJourney',
    backend: {
        loadPath: function(lng, ns){
            if(ns.indexOf('plan-names') !== -1){
                return '/online-services/plan-names';
            }else{
                return '/groups/' + 'locales/' + lng + '/' + ns + '.json';
            }
        }
    }
};

var initialized;

function init() {
    if (initialized === undefined) {
        initialized = i18n.doSetup(options);
    }
    return initialized;
}


module.exports = {
    init: init,
    translate: i18n.translate
};



/***/ }),

/***/ "pHlT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * This service provides session group scheme information, including basic contact information
 * uses session storage to cache groupScheme information
 * if request has been initiated and not yet resolved any new requests will return the promise of the first request
 * @author c_razmuss_a (Arturs Razmuss) on 16/02/2018
 */
var $ = __webpack_require__("7t+N");
var ajaxHandler = __webpack_require__("CCE4");
var store = __webpack_require__("JOWb");

//const
var cacheKey = 'groupSchemeBasicInfo';
/**
 * as the group scheme data are related to session there is no need to have multiple concurrent requests
 */
var fetchInProgress;

function getGroupScheme(refresh, groupSchemeToken) {
    if (refresh !== true && store.session.has(cacheKey)) {
        return $.Deferred().resolve(store.session.get(cacheKey)).promise();
    } else {
        return fetchGroupScheme(groupSchemeToken);
    }
}

function getContactInformation(refresh) {
    if (refresh !== true && store.session.has(cacheKey)) {
        return $.Deferred().resolve(store.session.get(cacheKey).vhiContacts[0]).promise();
    } else {
        return fetchGroupScheme()
            .then(function(groupSchemeBasicInfo) {
                return groupSchemeBasicInfo.vhiContacts[0];
            });
    }
}

function fetchGroupScheme(groupSchemeToken) {
    if (fetchInProgress) {
        return fetchInProgress;
    } else {
        // The case when user hasn't visited "/groups" page before "/myvhi" and there is no GroupScheme info in session
        // (can be called when displaying custom enrolment content)
        if(groupSchemeToken) {
            fetchInProgress = ajaxHandler.ajaxGetJson({url: '/groups/rest/schemeByToken', jsonString: {'token': groupSchemeToken} })
                .then(onSuccess)
                .always(onAlways);
        } else {
            fetchInProgress = ajaxHandler.ajaxGetJson({ url: '/groups/rest/scheme'})
                .then(onSuccess)
                .always(onAlways);
        }
        return fetchInProgress;
    }
    
    function onSuccess(groupSchemeBasicInfo) {
        store.session(cacheKey, groupSchemeBasicInfo);
        return groupSchemeBasicInfo;
    }

    function onAlways() {
        fetchInProgress = null;
    }
}

module.exports.getGroupScheme = getGroupScheme;
module.exports.getContactInformation = getContactInformation;


/***/ }),

/***/ "rzgQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("7t+N");
var contactPanelJade = __webpack_require__("S4PR");

function render(schemeData) {
    var vhiContactList = schemeData.vhiContacts;
    var schemeContactList = schemeData.schemeContacts;
    var dataObj = {
        groupSchemeCompany: schemeData.schemeName,
        groupSchemeNumber: schemeData.schemeId,
        webVhiContact: (vhiContactList && vhiContactList.length > 0) ? vhiContactList[0] : null,
        webCompanyContact: (schemeContactList && schemeContactList.length > 0) ? schemeContactList[0] : null
    };
    var html = contactPanelJade(dataObj);
    var $placeHolder = $('#scheme-specific-contact-panel');
    $placeHolder.html(html);
}

module.exports.render = render;

/***/ })

},["IwI5"]);


// WEBPACK FOOTER //
// /home.js